export default __webpack_public_path__ + "25fbbf690c0414af8678643afb33fca3.svg";